module.exports = __webpack_public_path__ + "img/no hay articulos.906aa6b3.png";